const mockData = {
  locations: [
    {
      id: 21,

      name: "GOA",
      description:
        "Goa is one of the most beautiful destinations of India for the couples planning to get married. People flock to Goa's beaches to make their matrimonial occasion cherished forever. Amidst the magical backdrop of the golden beaches where waves from the sea come and whisper something in your ears and allow your romance to continue forever, make your wedding special. The place offers a couple of ways to arrange a memorable wedding here - either by a wedding planner or by one of its luxurious hotels. If you want to arrange a beach wedding, it requires a permit and your wedding planner will take care of it.",
      images: [
        "assets/Images/Goa.jpg",
        "assets/Images/Goa1.jpg",
        "assets/Images/Goa2.jpg",
      ],
    },
    {
      id: 15,

      name: "Udaipur",
      description:
        "There are several reasons that make Udaipur an obvious destination for a wedding in India. The most primary one is its royal setting. Recognized as the city of lakes and palaces, Udaipur is one of the dreamiest and fascinating places in India that makes your wedding simply out of this world. A lot of allure comes to this city from its royal architectures.",
      images: [
        "assets/Images/udaipur.jpg",
        "assets/Images/udaipur2.jpg",
        "assets/Images/udaipur3.jpg",
      ],
    },
    {
      id: 18,

      name: "JODHPUR",
      description:
        "The 'Blue City' of Jodhpur is home to a number of graceful palaces, magnificent forts and breathtaking temples and offers a picture-perfect and awe-inspiring setting for a royal wedding. The historical splendor, delicate art-crafts and folk music make the atmosphere of the city actually romantic and vivacious. For your fairytale wedding in India, it is an ideal place to get married in a royal way. Experience the charm of the bygone era of Rajasthan and take the oath of lifetime togetherness.",
      images: [
        "assets/Images/Jodhpur.jpg",
        "assets/Images/Jodhpur1.jpg",
        "assets/Images/Jodhpur2.jpg",
      ],
    },
    {
      id: 20,

      name: "JAISALMER",
      description:
        "Get romantic with unusualness and royal grandeur of the city and plan a beautiful wedding in the Golden City of India. Jaisalmer is an ideal wedding venue with lots of forts and palaces. The city creates an utterly magical and brilliant picture of royal Rajasthan. Full of luxuriously built mansions, the city creates a beautiful world of golden fantasy in Rajasthan for a memorable wedding.",
      images: [
        "assets/Images/Jaisalmer.jpg",
        "assets/Images/Jaisalmer2.jpg",
        "assets/Images/Jaisalmer3.jpg",
      ],
    },
    {
      id: 19,

      name: "BIKANER",
      description:
        "Preserving medieval magnificence as the hallmark of the city, Bikaner brings numerous great opportunities to enjoy the royal wedding in Rajasthan. It features numerous spots where the theme wedding can be enjoyed. You might remember the Sidhwani's daughter's wedding in the film ‘Band Baaja Baaraat'. The wedding spot was Lalgarh Palace of Bikaner. There are several gorgeous architectures in Bikaner where a perfect destination wedding can be planned.",
      images: [
        "assets/Images/Bikaner.jpg",
        "assets/Images/Bikaner2.jpg",
        "assets/Images/Bikaner3.jpg",
      ],
    },
    {
      id: 13,

      name: "PUSHKAR",
      description:
        "Pushkar of Rajasthan is a city of holy temples that attracts tourists. Pushkar, a small town in Rajasthan, attracts tourists not only for Pushkar fair but also due to the grand and Wonderful weddings Destination in Pushkar here. If you want to make that moment more special and unique in your life then plan for Wedding in the beautiful holy city of Pushkar, Rajasthan. Pushkar's visit is mostly done by people who not only want to Make their Wedding Memorable but also receive blessings from ancient temples of Pushkar. Weddings in Pushkar are included in all the rites of Indian weddings. Like Decorated camels/horses/chariots form the groom's procession which is led by a brass band and other musicians.",
      images: [
        "assets/Images/Pushkar.jpg",
        "assets/Images/Pushkar2.jpg",
        "assets/Images/Pushkar3.jpg",
      ],
    },
    {
      id: 22,

      name: "AGRA",
      description:
        "Your wedding can be nowhere more beautiful than Agra – a place that is known for being home to the monument of love. Taj Mahal depicts an evergreen impression of love. Along with the rich Mughal culture, Agra offers a pristine atmosphere all around on your wedding. It is undoubtedly one of the most stunning wedding destinations in India. Under the dark blanket of twinkling stars at the night and with an array of Mughal cuisines, your day becomes a wonderful experience.",
      images: [
        "assets/Images/agra.jpg",
        "assets/Images/agra3.jpg",
        "assets/Images/agra4.jpg",
      ],
    },
    {
      id: 12,
      name: "Jaipur",
      description:
        "The 'pink city' of Jaipur is an ultimate destination for those who want to get married amidst sheer royalty. The city ranges from authentic ornate palaces like Raj Palace, Rambagh Palace, and Jai Mahal Palace – to stunning old mansions. For people seeking less expensive options, Jaipur features lots of old mansions to be ideal for it. Alsisar Haveli and Mandawa Haveli are some of the greatest choices and if you want your wedding in a heritage venue, Samode Palace is a place for you.",
      images: [
        "assets/Images/jaipur.jpg",
        "assets/Images/jaipur2.jpg",
        "assets/Images/jaipur3.jpg",
      ],
    },
  ],
};

export default mockData;
